var React = require('react');

function Edit (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M0 0H42V42H0V0Z","fill":"white","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M13 25.6691V29.0025H16.3334L26.1647 19.1712L22.8313 15.8378L13 25.6691ZM28.7425 16.5934C29.0892 16.2467 29.0892 15.6867 28.7425 15.34L26.6625 13.26C26.3158 12.9133 25.7558 12.9133 25.4091 13.26L23.7824 14.8867L27.1158 18.2201L28.7425 16.5934Z","fill":"#4C3371","key":1})]);
}

Edit.defaultProps = {"width":"42","height":"42","viewBox":"0 0 42 42","fill":"none"};

module.exports = Edit;

Edit.default = Edit;
